import { SxProps } from '@mui/material'

interface PartnersListStyle {
  container: SxProps
  partnerListItem: SxProps
  colorBar: SxProps
  partnerName: SxProps
}

export const partnerListStyles: PartnersListStyle = {
  container: {
    p: 2.5,
    padding: 2.5,
    height: 'auto',
    borderRadius: 4,
    borderColor: 'border.secondary',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: 'background.default',
    boxShadow:
      '0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03), 0 2px 2px -1px rgba(10, 13, 18, 0.04);',
  },
  partnerListItem: {
    display: 'flex',
    padding: 1.5,
    gap: 1.5,
    borderRadius: 2,
    '&:hover': {
      backgroundColor: 'background.secondary',
    },
  },
  colorBar: {
    width: 5,
    height: 24,
    borderRadius: 1,
  },

  partnerName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
    p: 0,
  },
}
